import { Component, inject } from '@angular/core';
import {PenaltyComponent} from "../penalty/penalty.component";
import {GameService} from "../../services/game.service";
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogContent, MatDialogActions } from "@angular/material/dialog";
import {KickPenaltyDialogOptions} from "../../model/penaltyDialog";
import {PlayType} from "../../model/playType";
import {SetPlayResultCommand} from "../../commands/SetPlayResultCommand";
import {PlayResult} from "../../model/playResult";
import {SetPenaltyCommand} from "../../commands/SetPenaltyCommand";
import {SetPenaltyAfterPlayCommand} from "../../commands/SetPenaltyAfterPlayCommand";
import {SetYardLineCommand} from "../../commands/SetYardLineCommand";
import {SetDistanceCommand} from "../../commands/SetDistanceCommand";
import {FirstDownCommand} from "../../commands/FirstDownCommand";
import {RepeatLastDownCommand} from "../../commands/RepeatLastDownCommand";
import {SetOdkCommand} from "../../commands/SetOdkCommand";
import {CalculateDistanceCommand} from "../../commands/CalculateDistanceCommand";
import {CalculateYardLineCommand} from "../../commands/CalculateYardLineCommand";
import {IncreaseDownCommand} from "../../commands/IncreaseDownCommand";
import {ApplyDownRulesCommand} from "../../commands/ApplyDownRulesCommand";
import {ODK} from "../../model/odk";
import {GamePlay} from "../../model/game-play";
import {SetKickerCommand} from "../../commands/SetKickerCommand";
import {SetKickYardCommand} from "../../commands/SetKickYardCommand";
import { TranslocoService, TranslocoModule } from "@ngneat/transloco";
import {HomeAway} from "../../model/home-away";
import {SwitchTeamsCommand} from "../../commands/SwitchTeamsCommand";
import { GroupCommands } from '../../commands/GroupCommands';
import { wrapInGroup } from '../../helpers/wrapInGroup';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { SousTitreBlocComponent } from '../sous-titre-bloc/sous-titre-bloc.component';
import { ButtonToggleGroupComponent } from '../button-toggle-group/button-toggle-group.component';
import { MatButtonToggleGroup, MatButtonToggle } from '@angular/material/button-toggle';
import { MatButton } from '@angular/material/button';
import { WheelSelectorComponent } from '../wheel-selector/wheel-selector.component';

@Component({
    selector: 'app-penalty-kick',
    templateUrl: './penalty-kick.component.html',
    styleUrls: ['./penalty-kick.component.scss'],
    imports: [CdkScrollable, MatDialogContent, SousTitreBlocComponent, ButtonToggleGroupComponent, MatButtonToggleGroup, MatButtonToggle, MatButton, WheelSelectorComponent, MatDialogActions, TranslocoModule]
})
export class PenaltyKickComponent extends PenaltyComponent {
  override game: GameService;
  override dialogRef: MatDialogRef<PenaltyComponent>;
  override dataPenalty: KickPenaltyDialogOptions;
  protected override translocoService: TranslocoService;

  // Le current YardLine initial du jeu en cours
  currentYard = ''
  ballGoes = ''

  constructor() {
    const game = inject(GameService);
    const dialogRef = inject<MatDialogRef<PenaltyComponent>>(MatDialogRef);
    const dataPenalty = inject<KickPenaltyDialogOptions>(MAT_DIALOG_DATA);
    const translocoService = inject(TranslocoService);

    super();
    this.game = game;
    this.dialogRef = dialogRef;
    this.dataPenalty = dataPenalty;
    this.translocoService = translocoService;


    if (!dataPenalty.kickType) throw new Error('No kick type.')
    this.initYardline = dataPenalty.initYardline
      // TODO pas sûr...
      || this.game.getFirstPendingGamePlay().yardLine
    this.currentYard = this.initYardline

    this.init();

    // Redéfinir l'initialisation de initYardline dans PenaltyKickComponent
    // this.initYardline = this.game.getCustomYardLine() || 'defaultYardLine';
  }

  override recalculerSpotTheBall() {
    // Si on arrive de l'override de recalculerSpotTheBall() de penality-kickoff,
    // on appelle immédiatement recalculerSpotTheBall de PenaltyComponent
    if (this.isKickOff()) {
      super.recalculerSpotTheBall()
      return
    }

    if (this.resultingDown === 'firstDown' && this.isBallGoesSwitchTeam()) {
      this.initYardline = this.dataPenalty.caughtOnYardLine
      console.log('recalculerSpotTheBall exception caughtOnYardLine', this.initYardline)
      super.recalculerSpotTheBall()
      return
    }

    console.log('this.isPenaltyOnPossessingTeam()', this.isPenaltyOnPossessingTeam())
    // Kick Away (ESC) + penalité Away / automatic 1st down => roulette = returned to, et changement de possession
    if (this.resultingDown === 'firstDown' && this.isPenaltyOnPossessingTeam()) {
      this.initYardline = this.dataPenalty.returnedTo
      console.log('recalculerSpotTheBall exception returnedTo', this.initYardline)
      super.recalculerSpotTheBall()
      return
    }

    this.initYardline = this.currentYard
    console.log('recalculerSpotTheBall normal', this.initYardline)
    super.recalculerSpotTheBall()
  }

  afficherBallGoes(): boolean {
    return this.resultingDown === 'firstDown'
  }

  setBallGoes(team: string) {
    this.ballGoes = team
  }

  override validation(valid: boolean, message: any[]): boolean {
    valid = super.validation(valid, message);

    // Quand le "1er down automatique" est choisi, la destination du ballon
    // (Domicile / Visiteur) doit être sélectionnée, sinon switchTeam() reçoit
    // une combinaison non gérée et lève "Combinaison impossible, mauvaises valeurs".
    if (this.afficherBallGoes() && !this.ballGoes) {
      valid = false;
      message.push(
        this.translocoService.translate('components.penalty.validation.ballGoes')
      );
    }

    return valid;
  }

  override repeatLastDown() {
    super.repeatLastDown();
    this.ballGoes = ''
  }

  // Pour penalty-kickoff
  repeatKick() {}

  override firstDown() {
    super.firstDown()
    this.ballGoes = ''
  }

  override save(): void {
    if (!this.isValid()) return;

    const currentGamePlay = this.game.getFirstPendingGamePlay()
    // TODO Pourquoi?
    if (!currentGamePlay?.playType) currentGamePlay.playType = PlayType.Run

    if (this.finishTagOnClose) {
      this.savePenalite(currentGamePlay);
    } else {
      this.savePenaliteAfterPlay(currentGamePlay);
    }
  }

  private savePenalite(currentGamePlay: GamePlay) {
    this.addResultingDownCommands();
    this.game.addCommand(
      new GroupCommands(`savePenalite`, [
        ...(this.isPunt() ? [new SetOdkCommand(currentGamePlay, ODK.Kick)] : []),
        new SetPlayResultCommand(currentGamePlay, PlayResult.Penalty),
        new SetPenaltyCommand(currentGamePlay, this.penaltyForHome(), this.penaltyYard, this.yardSpot),
      ])
    )
    this.game.addCommandsAfterTagging(this.tempCommandsAfterTagging)
    this.game.finishTagging(currentGamePlay)
    this.game.notifyGamePlayUpdate()
    this.dialogRef.close({navigateOnClose: true});
  }

  private savePenaliteAfterPlay(currentGamePlay: GamePlay) {
    this.game.addCommandsAfterTagging([
      new SetPenaltyAfterPlayCommand(currentGamePlay, this.penaltyForHome(), this.penaltyYard, this.yardSpot),
      new SetYardLineCommand(this.game.getNextGamePlay(), this.yardSpot),
      new SetDistanceCommand(this.game.getNextGamePlay(), this.penaltyYard),
      new FirstDownCommand(this.game.getNextGamePlay()),
    ])

    this.dialogRef.close({navigateOnClose: false});
  }

  /**
   * `true` si Kick off ou Onside Kick
   * @protected
   */
  protected isKickOff(): boolean {
    return false
  }

  private isPunt() {
    return this.dataPenalty.kickType === PlayType.Punt
  }

  override addResultingDownCommands() {
    if (!this.resultingDown) return

    const lastOdk = this.game.homeHasPossession() ? ODK.Offensive : ODK.Defensive;
    const currentGamePlay = this.game.getFirstPendingGamePlay();
    const nextGamePlay = this.game.getNextGamePlay(currentGamePlay)

    const resultingDownCommands: any = {
      repeatLastDown: () => {
        this.tempCommandsAfterTagging.push(...[
          new RepeatLastDownCommand(nextGamePlay, currentGamePlay),

          new CalculateDistanceCommand(nextGamePlay, currentGamePlay),
          new CalculateYardLineCommand(nextGamePlay, currentGamePlay)
        ]);

        this.addCommandsForRepeatLastDown()
      },
      firstDown: () => {
        const fakeGamePlay: GamePlay = {
          ...currentGamePlay,
          yardLine: this.yardSpot, // this.initYardline // returnedTo ou currentYard selon le cas
        }

        this.tempCommandsAfterTagging.push(
          new FirstDownCommand(this.game.getNextGamePlay(this.game.getFirstPendingGamePlay())),
          new CalculateYardLineCommand(nextGamePlay, fakeGamePlay),
        );

        if (this.switchTeam()) {
          this.tempCommandsAfterTagging.push(
            new SwitchTeamsCommand(nextGamePlay, currentGamePlay)
          )
        }

        this.addCommandsForFirstDown()

        this.tempCommandsAfterTagging = wrapInGroup(`Penality-kick addResultingDownCommands firstDown`, this.tempCommandsAfterTagging);
      },
      loosDown: () => {
        this.tempCommandsAfterTagging.push(...[
          new IncreaseDownCommand(nextGamePlay, this.game.getFirstPendingGamePlay()),
          new CalculateDistanceCommand(nextGamePlay, currentGamePlay),
          new ApplyDownRulesCommand(nextGamePlay, currentGamePlay, this.game.getNumberOfDowns())
        ]);
      },
      halfTheDistance: () => {
        return
      }
    };

    resultingDownCommands[this.resultingDown]();
  }

  addCommandsForRepeatLastDown() {
    const lastOdk = this.game.homeHasPossession() ? ODK.Offensive : ODK.Defensive;
    const currentGamePlay = this.game.getFirstPendingGamePlay();
    const nextGamePlay = this.game.getNextGamePlay(currentGamePlay)

    if (this.dataPenalty.kickType === PlayType.FG) {
      this.tempCommandsAfterTagging.push(...[
        new SetOdkCommand(nextGamePlay, lastOdk), // FIXME
      ])
    }

    if (this.dataPenalty.kickType === PlayType.Punt) {
      this.tempCommandsAfterTagging.push(...[
        new SetOdkCommand(nextGamePlay, currentGamePlay.odk),
      ])
    }
  }

  // Avec héritage?
  addCommandsForFirstDown() {
    const lastOdk = this.game.homeHasPossession() ? ODK.Offensive : ODK.Defensive;
    const currentGamePlay = this.game.getFirstPendingGamePlay();
    const nextGamePlay = this.game.getNextGamePlay(currentGamePlay)

    const tempCommandsAfterTagging = []
    if (this.dataPenalty.kickType === PlayType.FG) {
      if (!this.switchTeam()) {
        tempCommandsAfterTagging.push(
          // si FG attempt
          new SetOdkCommand(nextGamePlay, lastOdk), // FIXME
        );
      }
    }

    if (this.dataPenalty.kickType === PlayType.Punt) {
      if (!this.switchTeam()) {
        tempCommandsAfterTagging.push(
          // TODO à valider si le même cod que FG pourrait fonctionner
          new SetOdkCommand(nextGamePlay, currentGamePlay.odk)
        )
      }

      if (this.isBallGoesSwitchTeam()) {
        tempCommandsAfterTagging.push(
          new SetKickerCommand(this.game.getFirstPendingGamePlay(), this.dataPenalty.kicker),
          new SetKickYardCommand(this.game.getFirstPendingGamePlay(), this.dataPenalty.caughtOnYardLine)
        );
      }
    }

    this.tempCommandsAfterTagging.push(
      new GroupCommands(`Penality-kick  addCommandsForFirstDown`, tempCommandsAfterTagging)
    )
  }

  /**
   * Si la sélection du "Ball goes" change la possession
   */
  isBallGoesSwitchTeam(): boolean {
    if (this.resultingDown !== 'firstDown') return false

    const currentGamePlay = this.game.getFirstPendingGamePlay();
    if (!currentGamePlay.playType) throw new Error('Aucun currentGamePlay.playType')
    const isPossessionAway = this.game.getPossession(currentGamePlay) === HomeAway.Away;

    if (isPossessionAway && this.ballGoes === 'home') return true
    if (!isPossessionAway && this.ballGoes === 'away') return true

    return false
  }

  switchTeam(): boolean {
    const currentGamePlay = this.game.getFirstPendingGamePlay();
    const isPossessionAway = this.game.getPossession(currentGamePlay) === HomeAway.Away;

    const penalitePourHome = this.penaltyForHome();
    const penalitePourAway = !this.penaltyForHome();

    // Gérer le changement si ballGoes change de possession
    if (this.resultingDown === 'firstDown') {
      if (this.isBallGoesSwitchTeam()) return true
    }

    //
    if ([PlayType.Punt, PlayType.FG].includes(this.dataPenalty.kickType)) {
      return this.switchTeamIfPuntFGAttempt(isPossessionAway, penalitePourHome, penalitePourAway);
    }

    //
    if (this.dataPenalty.kickType === PlayType.KO) {
      return this.switchTeamIfKickOff(isPossessionAway, penalitePourHome, penalitePourAway);
    }

    throw new Error(`KickType non supporté`)
  }

  /**
   * Situations #1 - Punt, FG attempt
   *
   * // repeat kick : on part du current play pour calculer la pénalité.
   *
   * Kick Away (ESC) + penalité Home / automatic 1st down => roulette = current play, pas de changement de possession
   * Kick Away (ESC) + penalité Away / automatic 1st down => roulette = returned to, et changement de possession
   *
   * Kick Away (ESC) + penalité Home / repeat last down => roulette = current play, pas de changement de possession, on garde le même down
   * Kick Away (ESC) + penalité Away / repeat last down => roulette = current play, pas de changement de possession, on garde le même down
   *
   * @param KickAway
   * @param penalitePourHome
   * @param penalitePourAway
   * @private
   */
  private switchTeamIfPuntFGAttempt(KickAway: boolean, penalitePourHome: boolean, penalitePourAway: boolean) {
    // Situations #1 - Punt, FG attempt

    if (this.resultingDown === 'firstDown') {
      // automatic 1st down
      if (KickAway && penalitePourHome) return false
      if (KickAway && penalitePourAway) return true
    } else {
      // repeat last down
      if (KickAway && penalitePourHome) return false
      if (KickAway && penalitePourAway) return false
    }

    throw new Error('Combinaison impossible, mauvaises valeurs')
  }

  /**
   * Situations #2 - Kickoff
   *
   * repeat kick : on part du current play pour calculer la pénalité.
   *
   * Kick Away (ESC) + penalité Home / automatic 1st down => roulette = **caught on**, changement de possession
   * Kick Away (ESC) + penalité Away / automatic 1st down => roulette = **returned to**, changement de possession
   *
   * Impossible?!! : Kick Away (ESC) + penalité Home / ***repeat kick*** => roulette = current play, pas de changement de possession, on garde le même down
   * Kick Away (ESC) + penalité Away / ***repeat kick*** => roulette = current play, pas de changement de possession, on garde le même down
   *
   * @param KickAway
   * @param penalitePourHome
   * @param penalitePourAway
   * @private
   */
  private switchTeamIfKickOff(KickAway: boolean, penalitePourHome: boolean, penalitePourAway: boolean) {
    // Situations #2 - Kickoff

    if (this.resultingDown === 'firstDown') {
      // automatic 1st down
      if (KickAway && penalitePourHome) return true
      if (KickAway && penalitePourAway) return true
    } else {
      // repeat last down
      if (KickAway && penalitePourHome) throw new Error('Situation impossible?!!, Impossible?!! : Kick Away (ESC) + penalité Home / ***repeat kick*** => roulette = current play, pas de changement de possession, on garde le même down')
      if (KickAway && penalitePourAway) return false
    }

    throw new Error('Combinaison impossible, mauvaises valeurs')
  }
}
